import { api } from './auth.service';

const negocioDiretorioService = {
  listar:  async (negocioId)        => (await api.get(`/negocios-diretorios/negocio/${negocioId}`)).data,
  incluir: async (negocioId, dados) => (await api.post(`/negocios-diretorios/negocio/${negocioId}`, dados)).data,
  alterar: async (id, dados)        => (await api.put(`/negocios-diretorios/${id}`, dados)).data,
  excluir: async (id)               => (await api.delete(`/negocios-diretorios/${id}`)).data,
};

export default negocioDiretorioService;
